module.exports = __webpack_public_path__ + "img/sku-select-bg.823b8a3.jpg";